<template>
  <div class="row expanded" id="hero" :style="heroStyle">
    <div class="column">
      <div v-if="signUpCampaignPresent" class="row collapse">
        <div class="columns float-right medium-pull-1 medium-5">
          <slot name="campaign-badge"></slot>
        </div>
      </div>

      <div class="headline-text">
        <div class="row">
          <div class="columns small-24 medium-22 medium-offset-1 text-center">
            <p>
              <slot name="paragraph"></slot>
            </p>
            <h1>
              <slot name="heading"></slot>
            </h1>
  
            <div class="row">
              <div class="columns small-24 medium-16 medium-offset-4 large-12 large-offset-6">
                <mq-link class="cta" :destination="routes.signUpUrl" :size="ctaSize" type="button" :color="teamsiteConfig.color">
                  {{ signupBtnText }}
                </mq-link>
              </div>
            </div>
  
          </div>
        </div>
      </div>

      <div class="at-bottom">
        <div class="row">
          <div class="powered-by columns small-3 small-offset-1">
            <div v-if="isPoweredByMoqo">
              <svg-icon
                :name="poweredByImageName"
                fill="white"
                :size="poweredBySize"
              />
            </div>
          </div>

          <div class="column medium-16 end text-center hide-for-small-only">
            <mq-learn-more :scrollToElement="scrollTo">{{ learnMore }}</mq-learn-more>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ViewportDetectionMixin} from '@/components/ViewportDetection'

  export default {
    name: 'TeamsiteHero',
    mixins: [ViewportDetectionMixin],

    props: {
      /**
       * The path of the background image
       */
      imageUrl: {
        required: true,
        type: String
      },
      /**
       * The "learn more" text
       */
      learnMore: {
        required: true,
        type: String
      },
      /**
       * The element to scroll to when clicking "Learn More"
       */
      scrollTo: {
        required: false,
        type: String,
        default: '#more-info'
      }
    },

    data () {
      return {
        poweredBySize: '150px'
      }
    },
  
    mounted() {
      this.addTrackingDataToRegisterButton({
        element: this.$el.querySelector('a.moqo_link.cta'),
        section: 'hero'
      })
    },

    computed: {
      signUpCampaignPresent () {
        return !!(this.$slots['campaign-badge'])
      },

      ctaSize () {
        if (this.viewport == 'small') {
          return 'small'
        }
        return 'medium'
      },

      heroStyle () {
        return {
          backgroundImage: `url(${this.imageUrl})`
        }
      }
    },

    watch: {
      viewport () {
        this.poweredBySize = {
          small: '80px',
          medium: '110px',
          mediumlarge: '120px',
          large: '150px',
          xlarge: '150px'
        }[this.viewport]
      }
    }
  }
</script>

<style lang="scss">
  #hero {
    position: relative;
    height: 100vh;
    min-height: rem-calc(800);
    background-size: cover;
    background-position: 60% 0%;
    color: $color-white;

    @include breakpoint(medium only) {
      background-position: 30% 0%;
    }

    @include breakpoint(small only) {
      min-height: rem-calc(640);
    }

    .headline-text {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      margin-top: 0;
      transform: translateY(-50%);

      @include breakpoint(small only) {
        top: auto;
        bottom: 8rem;
        transform: none;
      }
    }

    h1 {
      font-size: rem-calc(60);
      line-height: rem-calc(60);

      @include breakpoint(medium down) {
        font-size: rem-calc(40);
        line-height: rem-calc(45);
      }
      
      @include breakpoint(small only) {
        // Fallback
        font-size: rem-calc(40);
        line-height: rem-calc(45);
        // Modern
        font-size: 9.5vw;
        line-height: 9.5vw;
      }
    }

    p {
      color: $color-white;
      text-transform: uppercase;
      font-size: rem-calc(20);
      line-height: rem-calc(25);
      margin-bottom: rem-calc(60);
      @include breakpoint(small only) {
        font-size: rem-calc(18);
        line-height: rem-calc(24);
        margin-bottom: rem-calc(100);
      }
    }
  
    .at-bottom {
      position: absolute;
      bottom: 2rem;
      left: 0;
      right: 0;
    }

    .cta {
      color: $white;
      max-width: 9999px;
      padding: .5em 2px;

      // make sure that the CTA is above the learn-more link if the height is too low
      position: relative;
      z-index: 2;
    }
    
    .powered-by{
      min-height: 1px;

      svg {
        height: auto;
      }
    }
    
    .scroll-down{
      margin-top: 4rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TeamsiteHero.vue